<template>
  <div style="margin: 4px 16px 16px;">
    <div class="content-input" style="margin-bottom: 8px;">
      <div class="content-input-left">
        <div class="dialog-input-item">
          <DatePickerRange title="赠送时间" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="dialog-input-item">
          <DatePickerRange title="使用时间" @date="getUseTime($event)" @check="getUseCheck($event)" :isChecked="isUseChecked"/>
        </div>
        <div class="dialog-input-item">
          <label>赠送类型</label>
          <el-select v-model="type" placeholder="Select" class="select-item">
            <el-option v-for="item in typeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <label style="margin-left: 16px">使用状态</label>
          <el-select v-model="isUse" placeholder="Select" class="select-item">
            <el-option v-for="item in isUseArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="dialog-input-item">
          <label>项目名称</label>
          <el-input type="text" v-model="searchValue" placeholder="请输入名称" class="select-item"  clearable>
            <template #prefix>
              <el-icon class="el-input__icon"><ElIcons name="search" /></el-icon>
            </template>
          </el-input>
          <el-checkbox v-model="limitState" style="margin-left: 8px;"><span style="white-space: nowrap">有限制</span></el-checkbox>
        </div>
      </div>
      <div class="content-input-right">
        <div class="dialog-input-btn">
          <ElButtons  type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
        </div>

      </div>
    </div>
    <el-table
        ref="multipleTableRef"
        :data="pageDataList"
        style="width: 100%; "
        v-loading="listLoading"
        size="default"
        border
    >
      <!--            <el-table-column property="id" label="ID" v-if="checkColList.indexOf('ID') > -1"/>-->
      <el-table-column property="giveTime" label="赠送时间" />
      <el-table-column property="giveShopName" label="赠送门店" />
      <el-table-column property="" label="赠送类型" >
        <template #default="scope">
          {{scope.row.type==1?'系统赠送':scope.row.type == 2?'邀请赠送':''}}
        </template>
      </el-table-column>
      <el-table-column property="name" label="项目名称"/>
      <el-table-column property="" label="使用状态" >
        <template #default="scope">
          {{scope.row.preBookId>0?'已使用':'未使用'}}
        </template>
      </el-table-column>
      <el-table-column property="useTime" label="使用时间"/>
      <el-table-column property="useShopName" label="使用门店" />
      <el-table-column property="" label="操作">
        <template #default="scope">
          <el-space wrap>
            <el-button v-if="scope.row.type==1" type="primary" size="small" @click="editPayDailog(scope.$index, scope.row)">赠送详情</el-button>
            <el-button v-if="scope.row.preBookId>0" type="warning" size="small" @click="editProBook(scope.$index, scope.row)">使用详情</el-button>
          </el-space>

        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalRow" style="text-align:right;margin-top: 24px;">
    </el-pagination>
  </div>
</template>

<script>
import { getFormData } from '@/api/api';
import {getPreBook, getProjectGivePageList, getRecordShops, getUserInfo, getWalletPayInfo} from '@/api/url';
// import Dialog from '@/assets/js/dialog'
// import AddUserRemarkDialog from './AddUserRemarkDialog';
import DatePickerRange from "@/components/DatePickerRange";
import Dialog from "@/assets/js/dialog";
import SearchInfoDialog from "@/views/user/components/SearchInfoDialog";
import {add} from "@/assets/shared/util";
import ProBookDialog from "@/views/preBook/components/ProBookDialog";
export default {
  props: {
    value: Object
  },
  components: {DatePickerRange},
  data() {
    return {
      pageDataList: [],
      userInfo: this.value.userInfo,
      totalRow: 0,
      pageSize: 20,
      currentPage: 1,
      listLoading: false,
      searchLoading: false,

      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      //时间
      useStartTime: '',
      useEndTime: '',
      isUseChecked: true,

      searchValue: '',
      searchType: 1,

      isUse: -1,
      isUseArray: [
        {label: '不限', value: -1},
        {label: '未使用', value: 0},
        {label: '已使用', value: 1},
      ],

      type: -1,
      typeArray: [
        {label: '不限', value: -1},
        {label: '系统赠送', value: 1},
        {label: '邀请赠送', value: 2},
      ],

      shopIdArray: [],
      shopIdArr:[],
      shopId: 0,

      limitState: false,

    }
  },
  methods: {

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },

    getUseTime(val) {
      this.useStartTime = val[0];
      this.useEndTime = val[1];
      // console.log(val)
    },
    getUseCheck(val) {
      this.isUseChecked = val
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['userId'] = this.userInfo.id;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['useStartTime'] = this.useStartTime;
      param['useEndTime'] = this.useEndTime;
      param['isUse'] = this.isUse;
      param['limitState'] = this.limitState?1:0;
      param['searchValue'] = this.searchValue;
      param['type'] = this.type;
      param['serviceType'] = -1;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getProjectGivePageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    editProBook(idx, item) {
      console.log('editable:' + this.editable)
      getFormData(getPreBook, {id: item.preBookId}).then(data => {
        let {msg, code} = data
        if (code == 200) {
          let _title = '预约详情';
          let bookForm = data.data
          bookForm.userInfo.userWallet.paySum = add([bookForm.userInfo.userWallet.paySumOne, bookForm.userInfo.userWallet.paySumTwo, bookForm.userInfo.userWallet.paySumThree, bookForm.userInfo.userWallet.paySumFour, bookForm.userInfo.userWallet.paySumOneGive, bookForm.userInfo.userWallet.paySumTwoGive, bookForm.userInfo.userWallet.paySumThreeGive, bookForm.userInfo.userWallet.paySumFourGive])
          bookForm.userInfo.userWallet.balanceSum = add([bookForm.userInfo.userWallet.balanceOne, bookForm.userInfo.userWallet.balanceTwo, bookForm.userInfo.userWallet.balanceThree, bookForm.userInfo.userWallet.balanceFour, bookForm.userInfo.userWallet.balanceOneGive, bookForm.userInfo.userWallet.balanceTwoGive, bookForm.userInfo.userWallet.balanceThreeGive, bookForm.userInfo.userWallet.balanceFourGive])
          Dialog.open({
            title: _title,
            component: ProBookDialog,
            data: {
              bookForm: bookForm,
              shopId: this.shopId,
              startTime: this.wStartTime,
              endTime: this.wEndTime,
              editable: false,
              appletOpen: false,
              ids: idx,
              width: '800px',
              from: 'give'
            },
            confirm: (result) => {
            }
          })
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },

    editPayDailog(idx, row) {

      // let visibleShopList = JSON.parse(sessionStorage.getItem('ownShopList')).filter(item => item.isEdit == 1)
      // if(visibleShopList.every(item => item.id != row.shopId)) {
      //   this.$message({
      //     showClose: true,
      //     duration: 1000,
      //     message: '当前角色没有该门店的编辑权限',
      //     type: 'warning'
      //   })
      //   return false
      // }

      getFormData(getWalletPayInfo, {id: row.sourceId}).then(data => {
        let {msg, code} = data
        if (code == 200) {
          let walletDetail = Object.assign({}, data.data);
          Dialog.open({
            title: '',
            component: SearchInfoDialog,
            data: {
              userForm: this.userInfo,
              walletDetail: walletDetail,
              width: '700px',
              editState: true,
              idx: idx,
            },
            confirm: () => {
              this.getPage()
            }
          })
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })


    }


  },
  mounted() {
    this.getPage();
  }
}
</script>

<style>

</style>
